export interface PhoneCode {
  isoCode: string
  phoneCode: string
  label: string
}

export const PHONE_CODES: PhoneCode[] = [
  { isoCode: 'UA', phoneCode: '380', label: 'Україна' },
  { isoCode: 'RU', phoneCode: '7',   label: 'Росія' },
  { isoCode: 'BY', phoneCode: '375', label: 'Білорусь' },
  { isoCode: 'KZ', phoneCode: '7',   label: 'Казахстан' },
  { isoCode: 'MD', phoneCode: '373', label: 'Молдова' },
  { isoCode: 'PL', phoneCode: '48',  label: 'Польща' },
  { isoCode: 'DE', phoneCode: '49',  label: 'Німеччина' },
  { isoCode: 'US', phoneCode: '1',   label: 'США' },
  { isoCode: 'CA', phoneCode: '1',   label: 'Канада' },
  { isoCode: 'GB', phoneCode: '44',  label: 'Великобританія' },
  { isoCode: 'AM', phoneCode: '374', label: 'Вірменія' },
  { isoCode: 'AZ', phoneCode: '994', label: 'Азербайджан' },
  { isoCode: 'GE', phoneCode: '995', label: 'Грузія' },
  { isoCode: 'LT', phoneCode: '370', label: 'Литва' },
  { isoCode: 'LV', phoneCode: '371', label: 'Латвія' },
  { isoCode: 'EE', phoneCode: '372', label: 'Естонія' },
  { isoCode: 'CZ', phoneCode: '420', label: 'Чехія' },
  { isoCode: 'SK', phoneCode: '421', label: 'Словаччина' },
  { isoCode: 'IL', phoneCode: '972', label: 'Ізраїль' },
  { isoCode: 'FR', phoneCode: '33',  label: 'Франція' },
  { isoCode: 'IT', phoneCode: '39',  label: 'Італія' },
  { isoCode: 'ES', phoneCode: '34',  label: 'Іспанія' },
  { isoCode: 'PT', phoneCode: '351', label: 'Португалія' },
  { isoCode: 'NL', phoneCode: '31',  label: 'Нідерланди' },
  { isoCode: 'SE', phoneCode: '46',  label: 'Швеція' },
  { isoCode: 'NO', phoneCode: '47',  label: 'Норвегія' },
  { isoCode: 'FI', phoneCode: '358', label: 'Фінляндія' },
  { isoCode: 'CH', phoneCode: '41',  label: 'Швейцарія' },
  { isoCode: 'AT', phoneCode: '43',  label: 'Австрія' },
  { isoCode: 'AU', phoneCode: '61',  label: 'Австралія' },
]

export function toFlagEmoji(isoCode: string): string {
  return [...isoCode.toUpperCase()].map(c => String.fromCodePoint(0x1F1E0 + c.charCodeAt(0) - 65)).join('')
}

export function findByIso(iso: string): PhoneCode | undefined {
  return PHONE_CODES.find(c => c.isoCode === iso.toUpperCase())
}
